import { useParams, useLocation } from "react-router-dom";

/**
 * custom hook to extract the organization slug from the URL
 * supports patterns like /intake/[org-slug]/dashboard or /intake/[org-slug]/auth/login
 */
export const useOrganizationSlug = (): string | null => {
  const params = useParams();
  const location = useLocation();

  // first try to get from URL params if using dynamic routing
  if (params.organizationSlug) {
    return params.organizationSlug;
  }

  // fallback: extract from pathname for current URL structure
  const pathSegments = location.pathname.split("/").filter(Boolean);

  // look for /intake/[slug] pattern
  const intakeIndex = pathSegments.indexOf("intake");
  if (intakeIndex !== -1 && pathSegments[intakeIndex + 1]) {
    return pathSegments[intakeIndex + 1];
  }

  return null;
};

/**
 * format organization slug into display name
 * removes hyphens and capitalizes each word
 * examples: "bakers" -> "Bakers", "allan-koba" -> "Allan Koba"
 */
export const formatOrganizationSlug = (slug: string | null): string => {
  if (!slug) {
    return "";
  }
  return slug
    .split("-")
    .filter((word) => word.length > 0) // filter out empty strings from consecutive hyphens
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};
